import AllhomesWatchlistButton from './allhomes-watchlist-button';
export default AllhomesWatchlistButton;